<style lang="scss" scoped>
.notRelease{
    color:#ff0000;
}
.el-range-editor.el-input__inner{
    width: 100%;
    border: 0px solid #dcdfe6;
}
.timeIsEdit{
    color:#507dac;
}
.noTimeIsEdit{
    color:#323232
}
.but-fill-time{
    position: absolute;
    top: 18px;
    right: 0px;
}
.but-fill-time img{
    width: 20px;
    height: 20px;
}
</style>

<template>
  <!-- :formatter="formatter" -->
    <el-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
        :min-width="width"
        :sortable="col.sortable"
        >
        <template slot="header" slot-scope="slot" >
            <span :data-id="slot.$index" v-if="editField.indexOf(col.prop) != -1 && !col.isbitian">
                <span style="color:#ff0101">*</span>
                {{col.label}}
            </span>
            <span v-else>{{col.label}}</span>
        </template>
        <!-- :render-header="renderHeader" -->
        <template slot-scope="scope" >
            <!-- 非管理员界面 -->
            <el-input type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow&&scope.$index!=(tableData.length-1)"  @focus='getfocus($event)' @blur.prevent="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" :maxlength="100" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');"/>
            <span v-if="editField.indexOf(col.prop) == -1  && !isAdmin && !isNoEditRow&&scope.$index!=(tableData.length-1)"> {{strGetVal(col.prop,scope)}}</span>


			<el-input type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-if="scope.row.materialName=='非主要产品'&&scope.column.label =='收入'&& !isAdmin && !isNoEditRow&&scope.$index==(tableData.length-1)"  @focus='getfocus($event)' @blur.prevent="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" :maxlength="100" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');"/>
            <span v-if="scope.column.label !='收入'  && !isAdmin && !isNoEditRow&&scope.$index==(tableData.length-1)"> {{strGetVal(col.prop,scope)}}</span>

            <!-- 非管理员界面 且 具有行属性-->
            <el-input type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && isNoEditRow &&unEditRow.indexOf(scope.$index)== -1"  @focus='getfocus($event)' @blur.prevent="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" :maxlength="100" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');"/>
            <span v-if="editField.indexOf(col.prop) == -1 && !isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)== -1"> {{strGetVal(col.prop,scope)}}</span>
            <span v-if="!isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)!= -1"> {{strGetVal(col.prop,scope)}}</span>
            
            <!-- 管理员界面 -->
           <div class="timeIsEdit" v-if="editField.indexOf(col.prop) != -1 && isAdmin && scope.row.completeFlag !=2" @click="chooseTime(scope.$index, scope.row,col.prop)" > 
                {{parseInt(scope.row.beginFillDate) | dateformat('YYYY.MM.DD')}}
                -{{parseInt(scope.row.endFillDate) | dateformat('YYYY.MM.DD')}} 
                <div class="but-fill-time"><img class="bm bm-img" src="@/asserts/img/btn_Fill.png"/></div>
            </div>
            <div class="noTimeIsEdit"  v-if="editField.indexOf(col.prop) != -1 && isAdmin && scope.row.completeFlag ==2" > 
                {{parseInt(scope.row.beginFillDate) | dateformat('YYYY.MM.DD')}}
                -{{parseInt(scope.row.endFillDate) | dateformat('YYYY.MM.DD')}} </div>
            <!-- 管理员界面 发布未发布 -->
            <span v-if="completeFlagObj && completeFlagObj.name.indexOf(scope.column.property) != -1  && isAdmin"> 
                <div :class="strGetVal(col.prop,scope)==2?'':'notRelease'">{{strGetVal(col.prop,scope)==2?'已发布':'未发布'}}</div>
            </span>
            <span v-if="completeFlagObj && completeFlagObj.name.indexOf(scope.column.property) == -1 && editField.indexOf(col.prop) == -1  && isAdmin"> {{strGetVal(col.prop,scope)}}</span>
        </template>
        <template v-if="col.children && !col.show">
            <digital-column
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :unEditRow="unEditRow"
                :editField="editField"
                :height="height" 
                :tableData="tableData"
                @modification="modificationa"
				@loseFocus="loseFocus"
                :width="item.width">
            </digital-column>
        </template>
    </el-table-column>
    
</template>

<script>
// import moment from 'moment'
// const R = require('ramda')
export default {
    name: "digital-column",
    data() {
        return {
            createTime:"",
            sth:"",
            field:[],
            tempkey:""
        };
    },
    props: {
        isNoEditRow:{
            type:Boolean
        },
        isAdmin:{
            type:Boolean
        },
        tableData:{
            type: Array
		},
        col: {
            type: Object
        },
        completeFlagObj:{
            type: Object
        },
        editField:{
            type: Array
        },
        unEditRow:{
            type: Array
        },
        formatterList:{
            type: Array
        },
		height:{
			type: String
		},
		formatteColumn:{
			type: Object
        },
        width:{
			type: String
		}
    },
    created(){
        //console.log(this.tableData);
    },
    methods: {
        chooseTime(index,row,prop){
            this.$emit("openDialog",{index:index,row:row,prop:prop});
        },
        //失去焦点
		loseFocus(e){
			this.$emit("loseFocus", this.tableData);
		},
		//input 监听
		modificationa(e){
			this.$emit("modification",e);
		},
        //获取到焦点
        getfocus(e){
            e.target.className = 'get-focus el-input__inner';
        },
        //失去焦点
        dblur(e){
            e.target.className = 'el-input__inner';
            this.$emit("loseFocus", this.tableData);
        },
        channelInputLimit(e,row,prop,col){
            // col.isInteger?value=value.replace(/^[0-9]*[1-9][0-9]*$/g,''):
            let rowprop = eval('row.'+prop );
            let key = e.key;
            //限制长度
            if((rowprop+"").length>10 && key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //整数的时候 不能输入小数点
            if(col.isInteger && key === '.'){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            var reg = /^\d+$|^\d*\.\d+$/g;
            if (key === '.' ) {
                if(  rowprop == "" || this.tempkey =='.' || rowprop.toString().indexOf('.') !=-1){
                   e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    return false;
                }else{
                    this.tempkey = key;
                    return true;
                }
            }else if(reg.test(key) || key === "Backspace"){
                this.tempkey = "";
                return true;
            }else{
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc(index,row,prop,e){
            let that = this;
            eval('row.'+prop+"= e" );
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
                new_arr[index] = row;
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        },
        strGetVal(row,scope){
            if(this.formatterList && this.formatterList.indexOf(scope.column.property) != -1) {//日期格式化
				let dataStr = eval('scope.row.'+row );
                return moment(parseInt(dataStr)).format('YYYY-MM-DD');
			}else if(this.formatteColumn && this.formatteColumn.name.indexOf(scope.column.property) != -1){
				return  this.formatteColumn.list[eval('scope.row.'+row )-1];
			}else{
                return  eval('scope.row.'+row );
            }
        },
        formatter(row, column, cellValue, index) {
            if(this.editField.indexOf(column.property) != -1) {
             if(cellValue.length >0){
                 return cellValue;
             }else{
                 return '请输入';
             }
            } else {
                return cellValue;
            }
		},
		formatteCol(row, column, value) {
			let prop = column.property;
			if (prop === "personClassify") {
				if( value == "1" ){
					return "高阶岗位"
				}else if( value == "2" ){
					return "普通岗位"
				}else if( value == "3" ){
					return "实习生"
				}else if( value == "4" ){
					return "劳务工"
				}
			}else {
				return value;
			}
		},
    }
};
</script>
